import { Core } from "@faire/design-tokens";
import { getHasReferralsR2M } from "@faire/retailer-visitor-shared/serialized-data/getHasReferralsR2M";
import { getRetailer } from "@faire/retailer-visitor-shared/serialized-data/getRetailer";
import { assignSettingR2BAwardConfiguration } from "@faire/retailer-visitor-shared/settings/getSettingR2BAwardConfiguration";
import { useR2BAwardStore } from "@faire/retailer-visitor-shared/stores/domain/useR2BAwardStore";
import {
  trackEvent,
  trackEventOnClick,
} from "@faire/web--source/common/trackEvent";
import { Button } from "@faire/web--source/slate/Button";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { TypographyStyles } from "@faire/web--source/ui/Typography";
import userBrandReferrals from "@faire/web-api--source/routes/www/user/brand-referrals";
import * as React from "react";
import { useEffect } from "react";
import styled from "styled-components";

export const RetailerToMakerReferral: React.FC = () => {
  useEffect(() => {
    assignSettingR2BAwardConfiguration();
  }, []);

  const hasReferralsR2M = getHasReferralsR2M();
  const retailerToken = getRetailer()?.token;
  const { r2bAdvertisedRetailerAwardFormatted } = useR2BAwardStore();

  const ref = useDoActionWhenVisible(() => {
    trackEvent(
      `${
        hasReferralsR2M ? "returning" : "new"
      }/retailer/${retailerToken}/show/footer`
    );
  });

  return (
    <Container ref={ref}>
      <Text>
        <StrictLocalMsg
          defaultMessage="Earn up to {amountMoney} for every brand you refer to Faire."
          description={{
            text: "Telling retailers they can earn up to a certain amount for referring brands",
          }}
          values={{
            amountMoney: r2bAdvertisedRetailerAwardFormatted,
          }}
        />
      </Text>
      <ReferButton
        linkTo={userBrandReferrals()}
        onClick={trackEventOnClick(
          `retailer-to-maker/entry/footer/${
            hasReferralsR2M ? "returning" : "new"
          }/retailer/${retailerToken}`
        )}
        variant="secondary"
      >
        <StrictLocalMsg
          defaultMessage="Refer Today"
          description={{ text: "Refer a brand and get a reward" }}
        />
      </ReferButton>
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  align-items: stretch;
  justify-content: flex-start;
  border-top: 1px solid ${Core.border.muted};
  padding: 32px 24px;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 30px 96px 60px;
    border-top-color: transparent;
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    max-width: 429px;
    padding: 24px 96px 60px 0;
    align-items: flex-end;
  }

  ${responsiveMediaQueries.xLargeAndAbove} {
    max-width: 530px;
  }
`;

const Text = styled.h3`
  ${TypographyStyles({ h4: true, serif: true })};
  max-width: 255px;
  margin: 0;

  ${responsiveMediaQueries.tabletAndAbove} {
    max-width: 100%;
  }
`;

const ReferButton = styled(Button)`
  min-width: 200px;
  width: fit-content;
  margin-top: 15px;
`;
